<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont icon-qiyezhandianxinxirizhi"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.SiteInformation') }}</div>
            </div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
            <el-form @submit.native.prevent class="table_header tableSearchForm"  size="small" label-width="80px" label-position="left">
                <el-form-item :label="$t('ems.SiteName')"><el-input v-model="form.name" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 400px"></el-input></el-form-item>
                <el-form-item :label="$t('ems.siteAddress')"><el-input type="textarea" :rows="4" v-model="form.textarea" style="width: 400px"></el-input></el-form-item>
                <el-form-item :label="$t('ems.OperationTime')">
                    <el-date-picker v-model="form.date" align="right" type="date" :placeholder="$t('ems.selectDate')" popper-class="dateDown" style="width: 400px"></el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('ems.sitePhoto')">
                    <el-upload
                            class="avatar-uploader"
                            action="/api/blade-wems/config/upload"
                            :show-file-list="false"
                            :headers="headers"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                        <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import spmsweb from '@/config/spmsweb';
    import { getStore } from "@/utils/store";
    import { Base64 } from 'js-base64';
    import i18n from "@/lang";

    export default {
        name: "mainSys",
        data(){
            return{
                opacity: 0,
                loading: false,
                form: {
                    imageUrl: ''
                }
            }
        },
        computed: {
            ...mapGetters(["language"]),
        },
        created(){
            this.headers = {
                Authorization: `Basic ${Base64.encode(
                    `${spmsweb.clientId}:${spmsweb.clientSecret}`
                )}`,
                "Blade-Auth": "bearer " + getStore({ name: "access_token" }),
                // 'Content-Type': 'application/json'
            };
        },
        mounted(){
            setTimeout(() => {
                this.opacity = 1;
            },200);
        },
        methods: {
            handleAvatarSuccess(res) {
                this.form.imageUrl ="http://192.168.22.207/" +  res.data;
                console.log( this.form.imageUrl)
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg' || 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error(i18n.t('ems.uploadedAvatarPicturetype')); 
                }
                if (!isLt2M) {
                    this.$message.error(i18n.t('ems.sizeUploadedPictureExceed'));
                }
                return isJPG && isLt2M;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/site";
    .win{
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
        }
        .content{
            overflow: hidden;
            height: calc(100% - 52px);
            box-sizing: border-box;
            padding: 20px;
            .table_header{
                height: 100%;
                background-color: var(--nav);
                border: #595959 solid 1px;
                box-sizing: border-box;
                padding: 50px;
                color: white;
            }
        }

    }
</style>
<style lang="scss">
    .table_header {
        .el-form-item__label {
            color: #b8b8b8 !important;
            font-size: 16px !important;
        }

        .avatar-uploader {
            .el-upload {
                border: 1px dashed  rgb(191, 191, 191);
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }
            .el-upload:hover {
                border-color: #409EFF;
            }
            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 178px;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }
            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }
        }
    }
</style>